module.exports = __webpack_public_path__ + "static/media/round-play_arrow-24px.9719f32c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/round-play_arrow-24px.svg
// module id = 252
// module chunks = 0